import { testDataCreator } from '@wix/answers-lib';
export var premiumStatusBuilder = testDataCreator({
    hasKB: false,
    hasPurchasedKB: false,
    hasCallCenter: false,
    hasPurchasedCallCenter: false,
    hasUnlimitedCallCenter: false,
    hasTicketing: false,
    hasPurchasedTicketing: false,
    hasChat: false,
    hasPurchasedChat: false,
    premium: false,
    hasPurchases: false,
    maxAgents: 1,
    trialDays: 14
});
//# sourceMappingURL=builder.js.map